import Vue from 'vue'
import Vuex from 'vuex'
import persistedstate from 'vuex-persistedstate'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import LocalStorage from './localStorage'

// pages state
import SiteRole from './pages/siteRole'
import PermissionRole from './pages/permissionRole'
import Download from './pages/download'
import Upload from './pages/upload'
import Batch from './pages/batch'
import Customer from './pages/customer'
import CustomerRank from './pages/customerRank'
import Log from './pages/log'
import Order from './pages/order'
import ExtraExport from './pages/extraExport'
import OrderDetail from './pages/orderDetail'
import Point from './pages/point'
import PointSetting from './pages/pointSetting'
import Account from './pages/account'
import Product from './pages/product'
import ProductDetail from './pages/productDetail'
import StockAlert from './pages/stockAlert'
import EcStock from './pages/ecStock'
import MasterColor from './pages/masterColor'
import MasterColorGroup from './pages/masterColorGroup'
import MasterSize from './pages/masterSize'
import MasterSizeGroup from './pages/masterSizeGroup'
import OrderQuantity from './pages/orderQuantity'
import MasterLogisticsCalendar from './pages/masterLogisticsCalendar'
import MailTemplate from './pages/mailTemplate'
import StockAdjustment from './pages/stockAdjustment'
import StockMove from './pages/stockMove'
import Destination from './pages/destination'
import PendingProduct from './pages/pendingProduct'
import Payment from './pages/payment'
import PaymentConvenience from './pages/paymentConvenience'
import PaymentCarrier from './pages/paymentCarrier'
import PaymentId from './pages/paymentId'
import Sales from './pages/sales'
import SalesDigital from './pages/salesDigital'
import SalesProductPhysical from './pages/salesProductPhysical'
import SalesProductDigital from './pages/salesProductDigital'
import SalesYell from './pages/salesYell'

Vue.use(Vuex)

export const defaultState = function () {
  return {
    serviceSiteConfigs: '',
    searchConditions: '',
    sites: '',
    activeNaviIndex: '',
    loggedIn: false,
    authApiKey: 'iwC6QJOv1B6SlXfKyy6wS3AE70xpkk8lO3YpjYZc',
    apiKey: '',
    tempKey: '',
    token: '',
    refreshToken: '',
    timeZone: '',
    tokenExp: '',
    accountId: '',
    accountUuid: '',
    accountType: '',
    role: {},
    convertedSearchConditions: {},
    mfaAuthStatus: '',
    fromAcnLogin: false
  }
}

export default new Vuex.Store({
  plugins: [
    persistedstate({ key: 'CCS', paths: ['LocalStorage'] }),
    persistedstate({ key: 'CCS', storage: window.sessionStorage })],
  state: defaultState(),
  actions,
  getters,
  mutations,
  modules: {
    LocalStorage,
    SiteRole,
    PermissionRole,
    Download,
    Upload,
    Batch,
    Customer,
    CustomerRank,
    Log,
    Order,
    ExtraExport,
    OrderDetail,
    Point,
    PointSetting,
    Account,
    Product,
    ProductDetail,
    StockAlert,
    EcStock,
    MasterColor,
    MasterColorGroup,
    MasterSize,
    MasterSizeGroup,
    OrderQuantity,
    MasterLogisticsCalendar,
    MailTemplate,
    StockAdjustment,
    StockMove,
    Destination,
    PendingProduct,
    Payment,
    PaymentConvenience,
    PaymentCarrier,
    PaymentId,
    Sales,
    SalesDigital,
    SalesProductPhysical,
    SalesProductDigital,
    SalesYell
  }
})
